import React from 'react';
import Udesk from 'Udesk';
// import ReactTable from 'udesk-react/src/components/react-table';
import UdeskTable from 'Component/common/udesk-table';
import UdeskPagination from 'Component/common/udesk-pagination';
import CustomFilterModal from 'Component/pages/components/custom-filter-modal';
import ListManageComponent from './component';
import './style.scss';
import { Popover, Button, Space, Input, Select } from 'udesk-ui';
import _isEmpty from 'lodash-es/isEmpty';
import ExportButton from 'Component/common/export-button';
// import { BatchedActions } from 'udesk_gm_ui';
// import AddToTaskModal from '../AddToTaskModal';
// import { ArrowDownSOutlined } from '@udesk/icons';
// import { postCallManageBatchReAsr } from 'src/api/call/manage/batch/reAsr';
// import { getSystemModule } from 'Udesk/system/subApp';
// import UdeskLocales from 'UdeskLocales';
// import LanguageSelect from 'Component/pages/components/LanguageSelect';

export default class ListManageTemplate extends ListManageComponent {
    render() {
        let {
            // sdkOptions,
            title,
            cacheKey,
            searchPlaceHolder,
            isWechatQa,
            hideKeywordType,
        } = this.props;
        let {
            judgeStrategy,
            customJudgeLogic,
            data,
            customName,
            customId,
            conditionList,
            tableDOMRef,
            tableRef,
            loading,
            selectedItems,
            // addToTaskModalVisible,
        } = this.privates;
        let {
            searchField,
            paging,
            // type,
            keywordType,
            // callLang,
        } = this.privates.storages;
        let { _columns, _isFilterVisible } = this.privates.computes;
        let { actions, locales } = this;
        let customCard = (
            <div className="custom-filter-info-type">
                <div className="index-management-custom-filter-Info">
                    <div>
                        {locales.components.common.customFilter.customFilterCondition}：
                        {_isEmpty(conditionList) && locales.components.common.customFilter.none}
                    </div>
                    <div>
                        {!_isEmpty(conditionList) &&
                            this.actions.fieldsFilterChange({ conditionList })}
                    </div>
                </div>
                <div>
                    {locales.components.common.customFilter.conditionRule}：
                    <span>
                        {judgeStrategy !== 3 &&
                            Udesk.enums.operatorRuleTypes.find(
                                (current) => current.id === judgeStrategy
                            ).name}
                        {judgeStrategy === 3 && customJudgeLogic}
                    </span>
                </div>
            </div>
        );
        return (
            <div className="qa-react-list-page">
                <div className="qa-react-list-page-header">
                    <div className="qa-react-list-page-header-title">{title}</div>
                </div>
                <div className="qa-react-list-page-body">
                    <div className="qa-react-list-page-functions">
                        <If condition={!isWechatQa}>
                            <div className="qa-react-list-page-functions-left-part pull-left">
                                <Space>
                                    {!hideKeywordType ? (
                                        <Select
                                            value={keywordType}
                                            style={{ width: 100 }}
                                            onSelect={actions.selectType}
                                            disabled={loading}
                                            options={Udesk.enums.applyRolesWithRobot.map((i) => ({
                                                label: i.name,
                                                value: i.keywordType,
                                            }))}
                                        />
                                    ) : null}

                                    <Input
                                        maxCount={20}
                                        showCount={true}
                                        maxLength={20}
                                        value={searchField}
                                        placeholder={searchPlaceHolder}
                                        onChange={actions.changeSearchField}
                                        disabled={loading}
                                    />

                                    {/* <LanguageSelect
                                        value={callLang}
                                        onChange={actions.onLanguageChange}
                                        allowClear
                                    /> */}

                                    <Button onClick={actions.searchItems} disabled={loading}>
                                        {locales.labels.query}
                                    </Button>
                                </Space>
                            </div>
                        </If>
                        <div className="qa-react-list-page-functions-right-part pull-right">
                            <Space>

                                <Popover content={customCard} placement="bottomRight">
                                    <Button
                                        onClick={actions.changeFilterVisible}
                                        disabled={loading}
                                    >
                                        {locales.labels.filter}
                                    </Button>
                                </Popover>
                                {!this.props.hiddenExportBtn && (
                                    <ExportButton
                                        disabled={loading}
                                        exportDataCount={paging.total}
                                        hasFilterCondition={!!conditionList.length}
                                        onClick={actions.exportCallList}
                                    />
                                )}
                                <Button onClick={actions.onPopoverVisible}>
                                    {locales.components.pages.customerServiceRankList.select.column}
                                </Button>
                            </Space>
                        </div>
                    </div>
                    <div ref={tableDOMRef} className="qa-react-list-page-content">
                        <UdeskTable
                            subtractedHeight={197}
                            columns={_columns}
                            loading={loading}
                            ref={tableRef}
                            cacheKey={cacheKey}
                            dataSource={data?.fieldDataList ?? []}
                            onRow={(record, index) => {
                                return { onClick: actions.gotoDetail.params(record) };
                            }}
                            pagination={false}
                            rowSelection={
                                Number(this.props.type) ===
                                    Udesk.enums.inspectDataSources.voiceCall.id
                                    ? {
                                        selectedRowKeys: selectedItems.map((i) => i.dataId),
                                        onSelect: actions.onSelectChange,
                                        onSelectAll: actions.onSelectAllChange,
                                    }
                                    : undefined
                            }
                        />
                    </div>
                </div>
                <div className="qa-react-list-page-footer">
                    <If condition={data && data.fieldDataList && data.fieldDataList.length > 0}>
                        <UdeskPagination
                            current={paging.pageNum}
                            pageSize={paging.pageSize}
                            total={paging.total}
                            onChange={actions.pageChanged}
                        />
                    </If>
                </div>
                {/* <AddToTaskModal
                    visible={addToTaskModalVisible}
                    inspectDataSource={Number(this.props.type)}
                    onAdded={actions.close}
                    onCancel={actions.close}
                    dataId={selectedItems.map((i) => i.dataId)}
                    lang={_selectedLang}
                /> */}
                <CustomFilterModal
                    visible={_isFilterVisible}
                    applyAction={actions.handleConditionApply}
                    judgeStrategy={judgeStrategy}
                    customJudgeLogic={customJudgeLogic}
                    conditionList={conditionList}
                    fieldAjax={actions.fieldAjax}
                    customName={customName}
                    customId={customId}
                    onConditionFilterSaved={this.props.onConditionFilterSaved}
                    cancel={actions.handleConditionCancelWithoutClearData}
                    type={this.props.type}
                    filterList={['f_8']}
                    filterInspectData
                />
            </div>
        );
    }
}
